import { Layout } from "@/components/layout/Layout";
import { usePageMeta } from "@/hooks/use-page-meta";
import { fieldNotes } from "@/data/fieldNotes";
import { Link } from "wouter";
import { Badge } from "@/components/ui/badge";

export default function FieldNotes() {
  usePageMeta("Field Notes", "Writing and observations on building systems, managing projects, and the reality of operating digital businesses.");

  // Sort by date descending
  const sortedNotes = [...fieldNotes].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  return (
    <Layout>
      <div className="container mx-auto px-6 max-w-4xl py-12 md:py-20">
        <header className="mb-16">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium tracking-tight mb-6">
            Field Notes
          </h1>
          <p className="text-xl text-muted-foreground leading-relaxed max-w-2xl">
            Observations, opinions, and half-formed thoughts on technology, business, and the chaotic space where they intersect.
          </p>
        </header>

        <div className="space-y-8">
          {sortedNotes.map(note => (
            <Link key={note.slug} href={`/field-notes/${note.slug}`}>
              <article className="group block bg-card border border-border p-8 md:p-10 rounded-3xl hover:border-accent/30 hover:shadow-md transition-all cursor-pointer">
                <div className="flex items-center gap-4 mb-4">
                  <time className="text-sm font-medium text-muted-foreground">
                    {new Date(note.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                  </time>
                  {note.draft && (
                    <Badge variant="outline" className="bg-secondary/50 text-xs tracking-wider">
                      Draft
                    </Badge>
                  )}
                </div>
                <h2 className="text-2xl md:text-3xl font-serif font-medium mb-4 group-hover:text-accent transition-colors">
                  {note.title}
                </h2>
                <p className="text-muted-foreground leading-relaxed text-lg">
                  {note.excerpt}
                </p>
              </article>
            </Link>
          ))}
          
          {sortedNotes.length === 0 && (
            <div className="py-24 text-center text-muted-foreground">
              No field notes published yet.
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
